<div class="flex items-center gap-4 px-6 pt-6 pb-5 border-b border-outline-variant">
  <div
    class="flex items-center justify-center w-10 h-10 rounded-full bg-primary-container shrink-0"
  >
    <mat-icon class="text-on-primary-container text-[20px]! w-5! h-5!">description</mat-icon>
  </div>
  <div>
    <h2 class="text-lg font-medium leading-tight">Použít šablonu</h2>
    <p class="text-sm text-on-surface-variant mt-0.5">Text šablony upravte dle vaší školy</p>
  </div>
</div>

<!-- Material zeroes the content's bottom padding when the dialog has actions,
     so pb-5 restores it; gap-4 spaces the blocks regardless of which render.
     The layout utilities need `!` too: Material's own `.mat-mdc-dialog-content`
     rules are unlayered and would otherwise win over Tailwind's utilities. -->
<mat-dialog-content class="max-h-none! overflow-visible! flex! flex-col! gap-4! pb-5!">
  <p class="text-sm">
    Šablonu je vždy potřeba upravit dle dané školy. Škola si vybere z nabídnutého textu pouze to, co
    je jí vlastní, případně doplní o další prvky.
  </p>

  @if (data.note) {
    <div
      class="flex items-start gap-3 rounded-xl border border-primary/20 bg-primary-container/40 px-4 py-3"
    >
      <mat-icon class="mt-0.5 shrink-0 text-primary!">info</mat-icon>
      <p class="text-sm leading-relaxed font-medium text-on-surface" [innerHTML]="data.note"></p>
    </div>
  }

  @if (data.fieldHasContent) {
    <!-- The checkbox's 40px touch target insets its 18px box by 11px; pulling
         that back lines it up with the text above. -->
    <mat-checkbox class="-ml-[11px]" [checked]="replace()" (change)="replace.set($event.checked)">
      <span class="text-sm">Nahradit všechen text v textovém poli.</span>
      <span class="block text-xs text-on-surface-variant">
        Bez zaškrtnutí se šablona přidá za stávající text.
      </span>
    </mat-checkbox>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="border-t border-outline-variant!">
  <button matButton (click)="dialogRef.close(null)">Zrušit</button>
  <button matButton="filled" (click)="dialogRef.close({ replace: replace() })">
    Rozumím, vyplnit
  </button>
</mat-dialog-actions>
